import axios from 'axios'
import store from '../store';
// import NProgress from 'nprogress'

const ReportsapiClient = axios.create({
    baseURL: process.env.VUE_APP_REPORTS_API_URL,
    withCredentials: true, // This is the default
})
ReportsapiClient.interceptors.request.use(config => { // Called on request
    // NProgress.start()
    store.state.layout.isLoading = true;
    return config
})
ReportsapiClient.interceptors.response.use(response => { // Called on response
    // NProgress.done()


    store.state.layout.isLoading = false;

    return response
})
export default ReportsapiClient